var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconIndisponivel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-indisponivel",
    transform: "translate(-1657 -250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2634",
    "data-name": "Rectangle 2634",
    transform: "translate(1657 250)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2948",
    "data-name": "Path 2948",
    d: "M5.57,9.14A3.57,3.57,0,1,0,2,5.57,3.555,3.555,0,0,0,5.57,9.14M3.523,4.38,6.76,7.625a2.263,2.263,0,0,1-1.19.325A2.377,2.377,0,0,1,3.19,5.57a2.2,2.2,0,0,1,.333-1.19M7.95,5.57a2.263,2.263,0,0,1-.325,1.19L4.38,3.523A2.2,2.2,0,0,1,5.57,3.19,2.377,2.377,0,0,1,7.95,5.57m.4,4.363a5.384,5.384,0,0,0,1.587-1.61v7.164h5.553V4.38H10.592a5.5,5.5,0,0,0-.658-1.587h5.553A1.581,1.581,0,0,1,17.073,4.38V15.487h.793v1.587H2V15.487H8.347V9.933m4.76-.793h1.587v1.587H13.107Z",
    transform: "translate(1656.067 249.463)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndisponivel);
export default __webpack_public_path__ + "static/media/icon-indisponivel.de5b08ab838cd891b6c964d7ae164578.svg";
export { ForwardRef as ReactComponent };